import { getCatalog, register } from "@/api/loan";

export default class User {
  constructor() {

  }
  register = (preRequestLoan) => {
    return register(preRequestLoan).then(response => {
      return response
    }).catch(error => {
      throw error.response.data.errors;
    });
  }

  getCatalog = (token_auth, saving) => {
    return getCatalog(token_auth, saving).then(response => {
      return response
    }).catch(error => {
      throw error;
    });
  }
}